import { render, staticRenderFns } from "./DataApp.vue?vue&type=template&id=0bc21680&scoped=true&"
import script from "./DataApp.vue?vue&type=script&lang=js&"
export * from "./DataApp.vue?vue&type=script&lang=js&"
import style0 from "./DataApp.vue?vue&type=style&index=0&id=0bc21680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc21680",
  null
  
)

export default component.exports